<div class="px-4 py-3">
  <app-top-banner (addClicked)="addItem.emit()"
                  (onButtonMenuAction)="onButtonMenuAction($event)"
                  *ngIf="!hideBreadcrumb"
                  [addPermission]="addPermission"
                  [dropMenuOnCreate]="dropMenuOnCreate"
                  [hideAdd]="hideAdd"
                  [image]="image"
                  [menuItems]="menus"
                  [billsFiltering]="billsFiltering"
                  [ngClass]="routeAnimationsElements"
                  [showHelp]="showHelp"
                  [title]="Analysis"
                  [addButtonName]="addButtonName | titlecase"
                  [useDropdownOnCreate]="useDropdownOnCreate"
                  [viewDetails]="viewDetails"
                   [useBackButton]="useBackButton"

                  >
  </app-top-banner>

  <div class="px-0">
    <div class="row no-print">
      <div class="col-md-12">
        <ng-content select="summary"></ng-content>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div [@tableSize]="viewDetails ? (smallForm ? 'eighty' : animationSize) : 'hundred'"
             [ngClass]="routeAnimationsElements" class="no-print content-item" style="--order: 3">

          <div class="page-container ">
            <div class="page-content">
              <div class="content-frame">
                <div>
                  <ng-content select="primary-panel"></ng-content>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div [@formSize]="
            viewDetails ? (smallForm ? 'twenty' : animationSize) : 'zero'
            " [ngClass]="routeAnimationsElements">
          <div>
            <div class="flex justify-between items-center hide-on-print">
              <div class="flex items-center max-w-[90%]">
                <span *ngIf="formTitle" class="text-[17px] leading-4 text-gray-500"><strong>{{ formTitle | titlecase }}</strong></span>
              </div>
              <button (click)="closeForm()" class="fa-pull-right cursor close-button !text-secondary-dark" mat-stroked-button>
                <mat-icon>close</mat-icon>
                {{ 'Close' | concat | translate }}
              </button>
            </div>

            <div class="w-100 h-[1px] mt-2 mb-3 bg-gradient-to-tr from-gray-300 to-primary-100"></div>
            <p *ngIf="loading">{{ 'Saving Data' | concat | translate }}</p>
            <mat-progress-bar *ngIf="loading" mode="indeterminate">
            </mat-progress-bar>
          </div>
          <div class="page-container">
            <div class="page-content">
              <div class="content-frame">
                <div class="{{ secondaryWithStyle ? 'p-3 shadow-sm rounded bg-white' : ''}}">
                  <ng-content select="secondary-panel"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.col-md-12 -->
      </div>
    </div>

  </div>
</div>
